export const SUCCESSION_DRAWER_OPEN = 'SUCCESSION_DRAWER_OPEN';
export const SUCCESSION_DRAWER_CLOSE = 'SUCCESSION_DRAWER_CLOSE';
export const SUCCESSION_PROFILE_DRAWER_UPDATE = 'SUCCESSION_PROFILE_DRAWER_UPDATE';